import { ConstructionModal } from 'shared/ui/modal';
import SuccessIcon from '../icons/success.svg';
import FailIcon from '../icons/fail.svg';
import { OutlineButton } from './outline-button';
import styles from './status-modal.module.scss';

export type StatusModalProps = {
  type: 'success' | 'failed' | 'inaccessible' | 'forbidden';
  subtitle?: string;
  onClose?: () => void;
};

export const StatusModal = ({ type, subtitle, onClose }: StatusModalProps) => {
  const defaultSubtitle = 'Повторите попытку или\u00A0попробуйте\u00A0позже';

  return (
    <ConstructionModal backgroundClassName={styles.background}>
      <div className={styles.modal}>
        <div className={styles.content}>
          {type === 'success' && (
            <>
              <img src={SuccessIcon} alt="" width={104} height={104} />
              <div className={styles.title}>Анкета успешно отправлена!</div>
              <div className={styles.text}>Мы скоро свяжемся с вами</div>
            </>
          )}
          {(type === 'failed' || type === 'inaccessible' || type === 'forbidden') && (
            <>
              <img src={FailIcon} alt="" width={104} height={104} />
              <div className={styles.title}>{type === 'forbidden' ? 'К\u00A0сожалению, вы\u00A0не\u00A0предоставили согласие на\u00A0использование данных из\u00A0Госуслуг' : 'Что-то пошло не так'}</div>
              <div className={styles.text}>{type === 'forbidden' ? 'Заполните анкету вручную' : (subtitle ?? defaultSubtitle)}</div>
              <OutlineButton
                onClick={() => (type === 'failed' ? onClose?.() : location.reload())}
                className={styles.closeButton}
              >
                {type === 'forbidden' ? 'Перейти к\u00A0ручному заполнению' : 'Закрыть и попробовать еще раз'}
              </OutlineButton>
            </>
          )}
        </div>
      </div>
    </ConstructionModal>
  );
};
